import type { ItemRenderer } from "./types";

export const renderFoldingTable: ItemRenderer = ({ svg, bboxPx }) => {
    const color = "#a64022";

    const shelfStroke = 0.45;
    const maxShelfH = Math.max(0, bboxPx.h - shelfStroke);
    const rawShelfH = Math.max(2, Math.min(8, bboxPx.h * 0.12));
    const shelfH = Math.min(rawShelfH, maxShelfH);

    const shelf = {
        x: bboxPx.x + shelfStroke / 2,
        y: bboxPx.y + shelfStroke / 2,
        w: Math.max(0, bboxPx.w - shelfStroke),
        h: shelfH,
    };

    svg.rect(shelf.w, shelf.h).move(shelf.x, shelf.y).fill("#fff").stroke({ width: shelfStroke, color });

    const y1 = bboxPx.y;
    const y2 = bboxPx.y + bboxPx.h;

    const xLeft = bboxPx.x + shelfStroke / 2;
    const xRight = bboxPx.x + bboxPx.w - shelfStroke / 2;

    svg.line(xLeft, y1, xLeft, y2).stroke({ width: shelfStroke, color, linecap: "butt" });

    svg.line(xRight, y1, xRight, y2).stroke({ width: shelfStroke, color, linecap: "butt" });
};
